import { getUrlParam } from '../url';
import { isFunction, isObject } from '../type';

/**
 * 从指定的范围中选择语言，如果没有，则返回默认语言
 * 不做具体的转换逻辑
 * @param selectArr
 * @param defaultLang
 * @returns {*
 */
function getLang(selectArr, { key, keyMap,defaultLang}) {
    let lang = getLangFromUrl(key) || getLangFromUa() || getLangFromNavigator();
    lang = formatLang(lang);
    let formattedArr = selectArr.map(formatLang);
    if (isObject(keyMap) && isFunction(keyMap[lang])) {
        lang = keyMap[lang](lang);//做映射
    }
    return formattedArr.indexOf(lang) > -1 ? lang : defaultLang;
}

function formatLang(lang = '') {
    return lang.replace(/\_/g, '-');
}

/**
 * 优先从url获取语言，否则从useragent中取
 * @param rang
 * @param defaultLang
 * @param key
 * @returns {*}
 */
function getLangFromUrl(key = 'lang') {
    return getUrlParam(key) || '';
}

/**
 * 从ua获取语言 适用于微信内部webview
 * @returns {*}
 */
function getLangFromUa() {
    const matchResult = typeof navigator === 'object' ? navigator.userAgent.match(/\s*Language\/([^\s]+)/) : '';
    return matchResult && matchResult[1] ? matchResult[1].toLowerCase() : '';
}

/**
 * 从navigator中获取
 * @returns {string}
 */
function getLangFromNavigator() {
    // ie10 没有 navigator.language, 有 userLanguage
    if (typeof navigator === 'object') {
      const { language, userLanguage, browserLanguage, systemLanguage } = navigator;
      return language || userLanguage || browserLanguage || systemLanguage || '';
    }
    return '';
}

export {
    getLang,
    getLangFromUrl,
    getLangFromNavigator,
    getLangFromUa
};
